import { ToothEndodontic } from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';
import parseEndodonticValue, { EndodonticValue } from './parseEndodonticValue';

type ToothEndodonticKey = keyof Omit<ToothEndodontic, '__typename'>;

const ENDODONTIC_KEY_MAP: Record<ToothEndodonticKey, string> = {
	cold: 'patientTreatment.meddiDENT.dentalCross.endodontic.cold',
	heat: 'patientTreatment.meddiDENT.dentalCross.endodontic.heat',
	electric: 'patientTreatment.meddiDENT.dentalCross.endodontic.electric',
	palpation: 'patientTreatment.meddiDENT.dentalCross.endodontic.palpation',
	percussion: 'patientTreatment.meddiDENT.dentalCross.endodontic.percussion',
};

const addPrefix = (text: string) => {
	const { t } = useTranslation();
	return `${t('patientTreatment.meddiDENT.history.text.endodonticPrefix')} ${t(
		text,
	)} - `;
};

export default function getHistoryValueEndodontic(endodontic: ToothEndodontic) {
	const { t } = useTranslation();

	const endodonticEntries = Object.entries(endodontic);

	if (endodonticEntries.length === 0) {
		return t('patientTreatment.meddiDENT.history.text.endodonticReset');
	}

	return endodonticEntries
		.map(([key, value]) => {
			return `${addPrefix(
				ENDODONTIC_KEY_MAP[key as ToothEndodonticKey],
			)}${parseEndodonticValue(value as EndodonticValue)}`;
		})
		.join(', ');
}
